'use client';

import type { ContentsType } from '@/types';
import { Carousel } from '@mantine/carousel';
import { AspectRatio, Box, Card, Group, Image, Stack } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import Link from 'next/link';
import { useState } from 'react';
import { CarouselControl } from './CarouselControl';
export const GamesCard: React.FC<ContentsType> = ({
  id,
  title,
  items
}) => {
  const [active, setActive] = useState(0);
  const isMobile = useMediaQuery('(max-width: 36em)');
  const handleNext = () => {
    setActive(prev => (prev + 1) % items.length);
  };
  const handlePrev = () => {
    setActive(prev => (prev - 1 + items.length) % items.length);
  };
  return <Card bg="var(--navbar-bg-color)" my={12} radius="sm">
      <Stack>
        <Group justify="space-between" wrap="nowrap" gap={4}>
          <Box>{title}</Box>
          <CarouselControl link="#" handleNext={handleNext} handlePrev={handlePrev} />
        </Group>

        <Box>
          <Carousel align="start" h="100%" slideSize={{
          base: '30%',
          sm: '20%',
          md: '14.2%'
        }} slideGap="md" loop withControls={false} initialSlide={active} onSlideChange={setActive}>
            {items.map(image => <Carousel.Slide key={image.id}>
                <AspectRatio ratio={isMobile ? 110 / 147 : 122 / 130}>
                  <Box component={Link} href="/game">
                    <Image src={image.imgCard} radius="md" alt={`game-${id}`} />
                  </Box>
                </AspectRatio>
              </Carousel.Slide>)}
          </Carousel>
        </Box>
      </Stack>
    </Card>;
};